"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCollegeApi = void 0;
exports.createCollegeApi = (axios) => ({
    listColleges() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/colleges')).data;
        });
    },
    createCollege(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post('/colleges', props)).data;
        });
    },
    updateCollege(_a) {
        var { collegeId } = _a, rest = __rest(_a, ["collegeId"]);
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.put(`/college/${collegeId}`, rest)).data;
        });
    },
    deleteCollege(props) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/college/${props.collegeId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sbGVnZUFwaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hcGkvY29sbGVnZUFwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsZ0JBQWdCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ25ELFlBQVk7O1lBQ2hCLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7UUFDN0MsQ0FBQztLQUFBO0lBRUssYUFBYSxDQUFDLEtBQXVCOztZQUN6QyxPQUFPLENBQUMsTUFBTSxLQUFLLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUNyRCxDQUFDO0tBQUE7SUFFSyxhQUFhLENBQUMsRUFNbkI7WUFObUIsRUFDbEIsU0FBUyxPQUtWLEVBSkksSUFBSSxjQUZXLGFBR25CLENBRFE7O1lBS1AsT0FBTyxDQUFDLE1BQU0sS0FBSyxDQUFDLEdBQUcsQ0FBQyxZQUFZLFNBQVMsRUFBRSxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDOztLQUM5RDtJQUVLLGFBQWEsQ0FBQyxLQUE0Qjs7WUFDOUMsTUFBTSxLQUFLLENBQUMsTUFBTSxDQUFDLFlBQVksS0FBSyxDQUFDLFNBQVMsRUFBRSxDQUFDLENBQUM7UUFDcEQsQ0FBQztLQUFBO0NBQ0YsQ0FBQyxDQUFDIn0=